"use strict";
/**
 * @module diffusion
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * An enum for the available log levels
 *
 * Accessible through `diffusion.LogLevel`.
 */
var LogLevel;
(function (LogLevel) {
    LogLevel["trace"] = "trace";
    LogLevel["debug"] = "debug";
    LogLevel["info"] = "info";
    LogLevel["warn"] = "warn";
    LogLevel["error"] = "error";
    LogLevel["silent"] = "silent";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/util/logger.js
// module id = 1732
// module chunks = 1